import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { selectLocale } from '@/store/selectors/commonSelectors';
import BffApiService from '@/shared/bffApiService';
import { CmsStaticTextContentType } from '@lucky7ventures/bff-types';
import { useBffRequest } from '@/hooks/useBffRequest';

export const useResponsibleGamingLoader = () => {
  const locale = useSelector(selectLocale);
  const { request, data, loading } = useBffRequest(BffApiService.getStaticTextContent);
  useEffect(() => {
    request({
      axiosConfig: { params: { contentType: CmsStaticTextContentType.responsibleGaming } },
    });
  }, [locale]);

  return {
    data,
    loading,
  };
};
